import React, { useEffect, useRef, useState } from 'react';
import { PortableText } from '@portabletext/react';
import { Grid, GridItem } from '@chakra-ui/react';
import { SectionZone } from '../SectionZone';
import { components } from '../RichText/components';

export default function Section({ data, children }) {
  const { body, rightColumn, leftColumn, alignItems, singleColumn, dropCap, textCentered } =
    data || {};
  const rightColumnRef = useRef(null);
  const leftColumnRef = useRef(null);
  const [isRightSticky, setIsRightSticky] = useState(false);
  const [isLeftSticky, setIsLeftSticky] = useState(false);

  useEffect(() => {
    const checkSticky = () => {
      const windowHeight = window.innerHeight - 100;
      const windowWidth = window.innerWidth;
      const rightColumnHeight = rightColumnRef?.current?.clientHeight;
      const leftColumnHeight = leftColumnRef?.current?.clientHeight;

      if (windowWidth >= 1280) {
        setIsRightSticky(rightColumnHeight < windowHeight);
        setIsLeftSticky(leftColumnHeight < windowHeight);
      } else {
        setIsRightSticky(false);
        setIsLeftSticky(false);
      }
    };

    checkSticky();

    window.addEventListener('resize', checkSticky);
    return () => {
      window.removeEventListener('resize', checkSticky);
    };
  }, []);

  return (
    <Grid
      gridTemplateColumns={{
        base: '1fr',
        xl: singleColumn ? '1fr' : 'minmax(0, 3fr) minmax(0, 7fr) minmax(0, 3fr)',
      }}
      gap={{ base: 30, xl: 60 }}
      alignItems={alignItems || 'flex-start'}
      maxWidth={singleColumn ? 'container.md' : 'none'}
      mx='auto'
      textAlign={textCentered && 'center'}
    >
      <GridItem
        display='flex'
        flexDirection='column'
        gap={30}
        position={isLeftSticky ? 'sticky' : 'static'}
        top='7.1875rem'
        px={{ base: 30, xl: 0 }}
        className='leftColumn'
        ref={leftColumnRef}
      >
        {leftColumn &&
          leftColumn.map((section) => (
            <SectionZone key={section._key || section._id} section={section} side />
          ))}
      </GridItem>

      <GridItem
        background='white'
        px={{ base: 30, xl: 0 }}
        className={`section ${dropCap ? 'dropCap' : ''}`}
      >
        {children}
        <PortableText value={body} components={components} />
      </GridItem>

      <GridItem
        display='flex'
        flexDirection='column'
        gap={30}
        position={isRightSticky ? 'sticky' : 'static'}
        top='7.1875rem'
        px={{ base: 30, xl: 0 }}
        className='rightColumn'
        ref={rightColumnRef}
      >
        {rightColumn &&
          rightColumn.map((section) => (
            <SectionZone key={section._key || section._id} section={section} side />
          ))}
      </GridItem>
    </Grid>
  );
}
